/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Webhook } from '../models/Webhook';
import type { WebhookEvent } from '../models/WebhookEvent';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebhookService {
    /**
     * Add a new Webhook
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns any Successfully added
     * @throws ApiError
     */
    public static postWebhook(
        workspaceId: string,
        requestBody: Webhook,
    ): CancelablePromise<{
        data?: {
            id?: string;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/webhook',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of Webhooks
     * @param workspaceId Workspace ID required
     * @returns Webhook Successfully retrieved list
     * @throws ApiError
     */
    public static getWebhook(
        workspaceId: string,
    ): CancelablePromise<Webhook> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/webhook',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a webhook
     * @param id The id of channel to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully updated
     * @throws ApiError
     */
    public static patchWebhook(
        id: string,
        workspaceId: string,
        requestBody: {
            /**
             * Indicates if custom conversions are enabled
             */
            custom_conversions: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/webhook/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletes a Webhook
     * @param id The id of channel to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted Webhook
     * @throws ApiError
     */
    public static deleteWebhook(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/webhook/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Webhook not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of webhook events
     * @param workspaceId Workspace ID required
     * @param webhookId Webhook ID required
     * @param limit Limit for pagination
     * @param offset Limit for pagination
     * @returns any Successfully retrieved list
     * @throws ApiError
     */
    public static getWebhookEvents(
        workspaceId: string,
        webhookId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<{
        data?: Array<WebhookEvent>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/webhook/events',
            query: {
                'workspace_id': workspaceId,
                'webhook_id': webhookId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
